const config = {
  clientId: process.env.REACT_APP_CLIENT_ID,
  tenant: process.env.REACT_APP_TENANT,
  redirectUri: "https://login.tdaburger.com/auth",
  policyName: "B2C_1_SignUpAndSignIn",
};

const getAuthUrl = () => {
  const authority = `https://${config.tenant}.b2clogin.com/${config.tenant}.onmicrosoft.com/${config.policyName}`;
  const params = new URLSearchParams({
    client_id: config.clientId,
    response_type: "code",
    redirect_uri: config.redirectUri,
    response_mode: "query",
    scope: "openid profile email",
    state: Math.random().toString(36).substring(7),
  });

  return `${authority}/oauth2/v2.0/authorize?${params.toString()}`;
};

const getLogoutUrl = () => {
  const authority = `https://${config.tenant}.b2clogin.com/${config.tenant}.onmicrosoft.com/${config.policyName}`;
  const params = new URLSearchParams({
    post_logout_redirect_uri: "https://login.tdaburger.com",
  });

  return `${authority}/oauth2/v2.0/logout?${params.toString()}`;
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch (error) {
    return true;
  }
};

export const authService = {
  login: () => {
    window.location.href = getAuthUrl();
  },

  logout: () => {
    sessionStorage.removeItem("authData");
    window.location.href = getLogoutUrl();
  },

  validateAuth: () => {
    const authData = sessionStorage.getItem("authData");
    if (!authData) return null;

    try {
      const data = JSON.parse(authData);
      if (!data.access_token || isTokenExpired(data.access_token)) {
        sessionStorage.removeItem("authData");
        return null;
      }
      return data;
    } catch (error) {
      sessionStorage.removeItem("authData");
      return null;
    }
  },

  handleAuthCallback: async (code) => {
    try {
      const tokenEndpoint = `https://${config.tenant}.b2clogin.com/${config.tenant}.onmicrosoft.com/${config.policyName}/oauth2/v2.0/token`;
      
      const params = new URLSearchParams({
        grant_type: "authorization_code",
        client_id: config.clientId,
        scope: "openid profile email",
        code: code,
        redirect_uri: config.redirectUri,
      });

      const response = await fetch(tokenEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params.toString(),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Token exchange error details:", errorData);
        throw new Error(errorData.error_description || "Failed to get access token");
      }

      const data = await response.json();
      
      // Get user info
      const userInfoEndpoint = `https://${config.tenant}.b2clogin.com/${config.tenant}.onmicrosoft.com/${config.policyName}/openid/v2.0/userinfo`;
      const userInfoResponse = await fetch(userInfoEndpoint, {
        headers: {
          Authorization: `Bearer ${data.access_token}`,
        },
      });

      if (!userInfoResponse.ok) {
        throw new Error("Failed to get user info");
      }

      const userInfo = await userInfoResponse.json();

      return {
        ...data,
        userInfo,
      };
    } catch (error) {
      console.error("Token exchange error:", error);
      throw error;
    }
  },
}; 